const Form090SC = {
    stepNames: {
        importantNotes: "重要提示",
        applicationInformation: "申请讯息",
        confirmation: "确认",
    },
    importantNotesContent: {
        title: "注意",
        p1: "在填写此表格前，请细心阅读个人资料收集声明。",
        declarationTitle: "声明",
        declarationList: [
            "教育局将使用本表格所载的个人资料作处理有关获提名教师出任课程发展议会辖下各学习领域及功能委员会委员的事宜。",
            "你必须提供所需的个人资料。如未能提供所需资料，或会影响其后的遴选工作及结果。",
            "你有权要求查阅及更正教育局所持有关你的个人资料。如欲查询本表格所收集的个人资料，请联络课程发展议会秘书处。",
        ],
    },
    label: {
        sectionA: {
            headerTitle: "甲部 （由获提名教师填写）",
            part1TitleBefore: "1 拟提名加入的委员会",
            part1TitleAfter: '（请于适当的空格加上"✓"（可选多于一个））',
            part2Title: "2 个人资料",
            englishSurname: "英文姓名（香港身份证）（姓氏） ",
            englishOtherName: "英文姓名（香港身份证）（名字）",
            chineseName: "中文姓名（香港身份证）",
            title: "称呼",
            otherTitle: "（请注明）",
            schoolName: "学校名称",
            telNo: "个人联络电话",
            email: "电邮地址",
            part3Title: "3 已获取的学历/专业资格（按时间顺序列出）",
            collegeName: "大学/学院",
            qualification: "资历/学位",
            obtainedYear: "考获年份",
            majorSubject: "主修科目",
            otherSubject: "其他科目",
            beforePart4TitleBoldText: "请提供",
            part4TitleBoldText: "过去十年（2012/13-2022/23学年）",
            afterPart4TitleBoldText: "的相关资料",
            part4ATitle: "4a 教学经验（按时间顺序列出）",
            schoolYearFromPart4A: "学年（由）",
            schoolYearToPart4A: "学年（至）",
            present: "现时",
            schoolNamePart4A: "学校名称",
            subjectPart4A: "任教科目",
            levelPart4A: "年级",
            part4bTitle: "4b 在校内担任的其他主要职务",
            schoolYearFromPart4B: "学年（由）",
            schoolYearToPart4B: "学年（至）",
            subjectPanel:
                "科组/功能组别/其他（例如：各科科组、训导组、教务组）",
            positionPart4B: "职位（例如：科主任、训导主任、教务主任）",
            part5Title:
                "5 与课程发展有关的专业组织的工作经验（例如：课程发展议会的工作、香港考试及评核局的工作、专业学会的经验）",
            schoolYearFromPart5: "学年（由）",
            schoolYearToPart5: "学年（至）",
            committeePart5:
                "委员会/组织（例如：课程发展议会委员会、香港考试及评核局科目委员会）",
            positionPart5: "职位（例如：主席、秘书、委员）",
            part6Title:
                "6 其他与课程发展相关的专业经验（例如：师资培训、编订学与教参考资料、从事研究/发表学术论著/统筹校本课程发展的工作）",
            schoolYearFromPart6: "学年（由）",
            schoolYearToPart6: "学年（至）",
            descriptionPart6:
                "项目/详情（例如：专题讲座、工作坊、种籽计划、行动研究）",
            positionPart6: "职位（例如：讲者、统筹员、作者）",
        },
        sectionB: {
            headerTitle: "乙部 （由校长填写）",
            recommendation: "评语（可选择是否填写）",
            conditionConfirm:
                "本人现就提名上述教师出任课程发展议会辖下委员会委员一事，证明甲、乙两部分所填报的资料属实。本人明白有关委员会或会在授课日的上午或下午举行会议，并同意尽量允许他/她出席会议。（若同意请在方格内加上✓号）",
            principalEnglishName: "校长姓名(英文)",
            principalChineseName: "校长姓名(中文)",
            title: "称谓",
            otherTitle: "（请注明）",
            email: "电邮地址",
        },
    },

    titleOptions: {
        Mr: "先生",
        Ms: "女士",
        Miss: "小姐",
        Other: "其他",
    },
    committeesOptions: [
        {
            title: "中国语文教育",
            subTitle: "学习领域委员会",
        },
        {
            title: "英国语文教育",
            subTitle: "学习领域委员会",
        },
        { title: "数学教育", subTitle: "学习领域委员会" },
        {
            title: "个人、社会及人文教育",
            subTitle: "学习领域委员会",
        },
        { title: "科学教育", subTitle: "学习领域委员会" },
        { title: "科技教育", subTitle: "学习领域委员会" },
        { title: "艺术教育", subTitle: "学习领域委员会" },
        { title: "体育", subTitle: "学习领域委员会" },
        {
            title: "幼儿教育",
            subTitle: "功能委员会",
        },
        {
            title: "特殊教育需要",
            subTitle: "功能委员会",
        },
        { title: "资优教育", subTitle: "功能委员会" },
        {
            title: "学习资源及支援",
            subTitle: "功能委员会",
        },
        { title: "应用学习", subTitle: "功能委员会" },
    ],
    errorMsg: {
        afterThisYear: "请输入{{targetYear}}或之后的年份",
        beforeThisYear: "请输入{{targetYear}}或之前的年份",
        suitableLanguage: "请以适当语言填写{{label}}",
        subjectPanel: "科组/功能组别/其他",
        descriptionPart6: "项目/详情",
        positionPart: "职位",
        committeePart5: "委员会/组织",
        chronological: "请输入{{targetYear}}或之后的年份",
        subjectRequired: "请输入对应的任教科目",
        yearBefore: "请选择今年之前的年份",
    },
};
export default Form090SC;
